var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcError = function SvgIcError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icError_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ED3B50",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M8.54 8.532a1.5 1.5 0 0 1 2.122 0l1.337 1.338 1.336-1.336a1.5 1.5 0 1 1 2.121 2.122L14.12 11.99l1.338 1.338a1.5 1.5 0 0 1-2.122 2.121L12 14.113l-1.335 1.335a1.5 1.5 0 1 1-2.121-2.122l1.335-1.335-1.338-1.338a1.5 1.5 0 0 1 0-2.12",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icError_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  })))));
};
export default SvgIcError;